import { print } from 'graphql'

import { ERROR_MESSAGES } from '@/constants/errorMessages'
import { ApiError } from '@/lib/api'
import { graphql } from '@/lib/gql'
import { UploadFilesMutation } from '@/lib/gql/graphql'
import { withBaseApiUrl } from '@/utils/withBaseApiUrl'

type UploadFilesResponse = {
  uploadedFileUids: string[]
}

const uploadFilesMutation = graphql(`
  mutation UploadFiles($input: UploadFilesInput!) {
    uploadFiles(input: $input) {
      uploadedFileUids
    }
  }
`)

export const uploadFiles = async (
  networkUid: string,
  files: File[],
): Promise<UploadFilesResponse> => {
  const operations = {
    query: print(uploadFilesMutation),
    variables: {
      input: { networkUid, files: [...new Array(files.length)].fill(null) },
    }, // アップロードするファイル分のサイズを持った配列を作成
    operationName: 'UploadFiles',
  }
  const map: { [key: number]: string[] } = {}
  files.forEach((_, i) => {
    map[i] = [`variables.input.files.${i}`]
  })

  // FormDataの構築
  const formData = new FormData()
  formData.append('operations', JSON.stringify(operations))
  formData.append('map', JSON.stringify(map))
  // fileをappend(keyはmapで指定している通りindex)
  files.forEach((file, i) => {
    formData.append(String(i), file)
  })

  const fetchRes = await fetch(withBaseApiUrl('/connect/query'), {
    method: 'post',
    body: formData,
    credentials: 'include',
  })

  // request自体が失敗している場合はnullを指定してデフォルトのエラーメッセージ（問題が発生しました...）が表示されるようにする。
  if (!fetchRes.ok) {
    throw new ApiError(ERROR_MESSAGES.defaultApiError)
  }
  const res: {
    data?: UploadFilesMutation
    errors?: { extensions: { status: number }; message: string }[]
  } = await fetchRes.json()
  if (res.errors) {
    const firstError = res.errors[0]
    const status = firstError.extensions.status
    const message = firstError.message
    throw new ApiError(message, { status })
  }
  if (!res.data) {
    throw new ApiError(ERROR_MESSAGES.defaultApiError)
  }
  return {
    uploadedFileUids: res.data.uploadFiles.uploadedFileUids,
  }
}
